<template>
  <div class="animated revealUp">
    <div class="section-title mb-3">
      {{ $t("edit") }} {{ $t("purchase") }} {{ $t("order") }}
    </div>
    <section class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedCinema"
                label="cine_name"
                track-by="cine_id"
                :placeholder="$t('Cinema')"
                :options="Cinemas"
                @select="onSelectCinema($event)"
                @remove="onSelectCinema($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedVendor"
                label="v_name"
                track-by="v_id"
                :placeholder="$t('Vendor')"
                :options="Vendors"
                @select="onSelectVendor($event)"
                @remove="onSelectVendor($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_selectVendor')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedVendor.length == 0"
              >Please Select Vendor.</span
            >
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="purchasOrderDetails.po_date"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="purchasOrderDetails.po_date"
                  name="purchasedate"
                  id="purchasedate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="
                    purchasOrderDetails.po_date &&
                    typeof purchasOrderDetails.po_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $t("purchaseorderdate") }}</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_PurchaseOrderDate')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('purchasedate')">{{
              errors.first("purchasedate")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="purchasOrderDetails.remarks"
              />
              <label>{{ $tc("remarks") }} (optional)</label>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("purchaseorderlock") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="purchasOrderDetails.po_lock"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ "Show All Raw Materials" }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="showAll"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="purchasOrderDetails.po_is_active"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <!-- <div class="col-md-12 mb-3 font-weight-bold">{{ $t("items") }}</div> -->
        <div
          class="w-100"
          v-if="purchasOrderDetails.cinema_id && purchasOrderDetails.v_id"
        >
          <b-collapse
            v-model="collapseObj.itemsArray"
            class="pt-3 px-2 bor mb-4 back collapse show w-100 purchase_table"
          >
            <section class="row">
              <div class="w-100 mx-3 mb-3">
                <span
                  class="redLine"
                  v-if="
                    purchaseOrderErrorDetails['hasError'] &&
                      purchaseOrderErrorDetails['errorMsg']
                  "
                  >{{ purchaseOrderErrorDetails["errorMsg"] }}</span
                >
                <table
                  class="swc-report-table po_table"
                  border="1"
                  style="table-layout: auto; background: white"
                >
                  <thead class="tableHeaderSticky">
                    <tr>
                      <th class="bg-lightgrey p-1" style="width: 320px">
                        Item
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 150px">QTY</th>
                      <th class="bg-lightgrey p-1" style="width: 150px">
                        Unit
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 150px">
                        Remarks
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 125px">
                        Tax %
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 125px">
                        Gross Rate
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 160px">
                        Net Total
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 125px">Tax</th>
                      <th class="bg-lightgrey p-1" style="width: 160px">
                        Gross Total
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 80px">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="RawMaterialsList.length > 0">
                    <tr
                      v-for="(item, vendorIndex) in RawMaterialsList"
                      :key="`${vendorIndex}${vendorIndex}`"
                      :class="
                        errIndex == vendorIndex
                          ? 'errRow'
                          : purchaseOrderErrorDetails['hasError'] &&
                            purchaseOrderErrorDetails[
                              'errorIndexArray'
                            ].includes(vendorIndex)
                          ? 'errorLine'
                          : !isNaN(String(item['poi_rate'])) &&
                            item['rm_id'] &&
                            item['poi_rate'] <= 0
                          ? 'redLine'
                          : ''
                      "
                    >
                      <td class="text-left p-0 po_item">
                        <multiselect
                          :key="`___${vendorIndex}${vendorIndex}`"
                          :class="`___${vendorIndex}${vendorIndex}`"
                          :options="
                            showAll
                              ? rawMaterialsNew
                              : filterRW(rawMaterialsNew)
                          "
                          v-model="item.main_raw_material"
                          :searchable="true"
                          label="rm_name"
                          track-by="rm_id"
                          placeholder=" Raw Material"
                          @select="
                            onSelectNewRawMaterial($event, vendorIndex, 0)
                          "
                          @remove="
                            onSelectNewRawMaterial(
                              $event,
                              vendorIndex,
                              0,
                              'remove'
                            )
                          "
                          :showLabels="false"
                        ></multiselect>
                      </td>
                      <td class="text-center p-0">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_qty"
                            min="0"
                            :name="`item_qty_${vendorIndex}`"
                            :id="`item_qty_${vendorIndex}`"
                            type="number"
                            class="qtyInput purchase_input"
                            @input="calculateNetAmount(item)"
                            placeholder="Qty"
                          />
                        </div>
                      </td>
                      <td class="text-left p-0 po_item">
                        <multiselect
                          :options="item.uom_units"
                          v-model="item.selectedUOM"
                          :disabled="DISABLE_RAW_MATERIAL_UOM_SWITCH == 'Y'"
                          :searchable="true"
                          label="uom_short_form"
                          track-by="uom_id"
                          placeholder="UOM"
                          :showLabels="false"
                          @select="onSelectUom($event, vendorIndex)"
                        />
                      </td>
                      <td class="text-left p-0 po_item">
                        <textarea
                          style="border-radius: 5px"
                          class="w-100 form-control form-control-sm"
                          placeholder
                          type="text"
                          v-model="item.poi_remarks"
                          rows="1"
                        ></textarea>
                      </td>
                      <td class="text-center p-0 po_item">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_tax_in_percentage"
                            min="0"
                            type="number"
                            name="taxamount"
                            id="taxamount"
                            @input="calculateNetAmount(item)"
                            v-validate="'required|decimal'"
                            placeholder="."
                            class="w-50 qtyInput purchase_input"
                          />
                          <span class="percentText">%</span>
                        </div>
                      </td>
                      <td class="text-center p-0">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_rate"
                            min="0"
                            type="number"
                            @input="calculateNetAmount(item)"
                            placeholder="Rate"
                            class="qtyInput purchase_input"
                          />
                        </div>
                      </td>
                      <td class="text-right">
                        {{ currFormat(item.poi_price) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(item.poi_tax_amount) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(item.poi_total_amount) }}
                      </td>
                      <td>
                        <div
                          class="icon-sm-minus blue-icon ml-2 btn"
                          @click="removeVendor(vendorIndex)"
                        ></div>
                      </td>
                    </tr>
                    <tr class="">
                      <td colspan="11">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click="addVendor()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="RawMaterialsList.length > 0">
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="2" class="font-weight-bold text-left">
                        Net Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{
                          currFormat(
                            RawMaterialsList.reduce(
                              (acc, { poi_price }) =>
                                acc + parseFloat(poi_price || 0),
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="2" class="font-weight-bold text-left">
                        Tax Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{
                          currFormat(
                            RawMaterialsList.reduce(
                              (acc, { poi_tax_amount }) =>
                                acc + parseFloat(poi_tax_amount || 0),
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="2" class="font-weight-bold text-left">
                        Gross Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{
                          currFormat(
                            RawMaterialsList.reduce(
                              (acc, { poi_total_amount }) =>
                                acc + parseFloat(poi_total_amount || 0),
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="10"></td>
                    </tr>
                    <tr class="">
                      <td colspan="10">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click="addVendor()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>
        </div>

        <div class="section-wrapper col-12 px-3 mb-3" v-if="false">
          <div class="d-flex">
            <div
              class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center"
            >
              <div
                class="fs-17 font-weight-bold pl-2 align-items-center"
                @click="collapseObj.itemsArray = !collapseObj.itemsArray"
              >
                <div class="">{{ $t("items") }}</div>
              </div>
              <span
                class="icon-collapse-up blue-icon mx-1 btn float-right"
                style="height: 30px; cursor: pointer"
                v-if="collapseObj.itemsArray"
                @click="collapseObj.itemsArray = !collapseObj.itemsArray"
              ></span>
              <span
                class="icon-collapse blue-icon mx-1 btn float-right"
                style="height: 30px; cursor: pointer"
                v-if="!collapseObj.itemsArray"
                @click="collapseObj.itemsArray = !collapseObj.itemsArray"
              ></span>
            </div>
          </div>
          <b-collapse
            v-model="collapseObj.itemsArray"
            class="pt-3 px-2 bor mb-4 back collapse show"
          >
            <section class="row">
              <div
                v-for="(item, vendorIndex) in RawMaterialsList"
                :key="`${vendorIndex}${vendorIndex}`"
                class="col-md-12"
              >
                <div class="row mb-3 align-items-center px-4" style="zoom: 0.9">
                  <div class="col-md-11 inner-vendor-rate">
                    <div class="row pt-3">
                      <div
                        class="col-md-3"
                        :key="`__${vendorIndex}${vendorIndex}`"
                        :class="`__${vendorIndex}${vendorIndex}`"
                      >
                        <multiselect
                          :key="`___${vendorIndex}${vendorIndex}`"
                          :class="`___${vendorIndex}${vendorIndex}`"
                          :options="
                            showAll
                              ? rawMaterialsNew
                              : filterRW(rawMaterialsNew)
                          "
                          v-model="item.main_raw_material"
                          :searchable="true"
                          label="rm_name"
                          track-by="rm_id"
                          placeholder="Select Raw Material"
                          @select="
                            onSelectNewRawMaterial($event, vendorIndex, 0)
                          "
                          :allowEmpty="false"
                          :showLabels="false"
                        ></multiselect>
                        <p class="error_message">
                          <span v-if="submitted && item.rm_name.length == 0"
                            >Please Select Raw Material.</span
                          >
                        </p>
                      </div>

                      <div class="">
                        <div class="d-flex align-items-center pt-2">
                          <label class="mr-2">{{ "Show All" }}</label>
                          <b-form-checkbox
                            class="j-checkbox mb-1 pb-0"
                            v-model="item.showAll"
                            name="check-button"
                          ></b-form-checkbox>
                        </div>
                        <p class="error_message">
                          <span></span>
                        </p>
                      </div>

                      <div class="col-md-2">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              v-model="item.poi_qty"
                              type="number"
                              @input="calculateNetAmount(item)"
                              placeholder="Qty"
                            />
                            <label
                              :class="
                                item.poi_qty && item.poi_qty.length > 0
                                  ? 'shift-up'
                                  : ''
                              "
                              >Qty</label
                            >
                          </div>
                        </div>
                        <p
                          v-if="submitted && item.poi_qty.length == 0"
                          class="error_message"
                        >
                          Please Select Quantity.
                        </p>
                      </div>

                      <div class="col-md-3">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-curve-container">
                            <label
                              :class="
                                item.uom_unit.length > 0 ? 'shift-up' : ''
                              "
                            >
                              UOM</label
                            >
                            <b-dropdown
                              :text="item.uom_unit"
                              variant="dropdown-curve"
                              class="w-100"
                              v-b-tooltip.hover.top="
                                $t('purchaseOrder_selectUOM')
                              "
                            >
                              <b-dropdown-item
                                v-for="(measurement,
                                measurementkey) in item.uom_units"
                                :key="measurementkey"
                                v-on:click="
                                  onSelectUom(measurement, vendorIndex)
                                "
                                >{{ measurement.uom_unit }}</b-dropdown-item
                              >
                            </b-dropdown>
                          </div>
                          <!-- <Tooltip :title="$t('purchaseOrder_selectUOM')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && item.uom_id.length == 0"
                            >Please Select Unit of measurement.</span
                          >
                        </p>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              v-model="item.poi_rate"
                              type="number"
                              @input="calculateNetAmount(item)"
                              placeholder="Qty"
                            />
                            <label
                              :class="
                                item.poi_rate && item.poi_rate.length > 0
                                  ? 'shift-up'
                                  : ''
                              "
                              >Rate</label
                            >
                          </div>
                        </div>
                        <p
                          v-if="submitted && item.poi_rate.length == 0"
                          class="error_message"
                        >
                          Please Select Rate.
                        </p>
                      </div>

                      <div class="col-md-2">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              :disabled="true"
                              v-model="item.poi_price"
                              type="text"
                              name="netamount"
                              id="netamount"
                              v-validate="'required|decimal'"
                              placeholder="."
                            />
                            <label>{{ $t("netAmount") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('purchaseOrder_NetAmount')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('netamount')">{{
                            errors.first("netamount")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-md-2">
                        <div class="input-material">
                          <input
                            v-model="item.poi_tax_in_percentage"
                            type="number"
                            name="taxamount"
                            id="taxamount"
                            @input="calculateNetAmount(item)"
                            v-validate="'required|decimal'"
                            placeholder="."
                          />
                          <label>{{ $t("Tax(In %)") }}</label>
                        </div>
                        <label
                          style="font-size: 10px; font-weight: bold"
                          v-if="item.poi_tax_amount"
                          >Tax Amount ({{ item.poi_tax_amount }})</label
                        >
                        <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" />-->
                        <p class="error_message">
                          <span v-if="submitted && errors.has('taxamount')">{{
                            errors.first("taxamount")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-md-2">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              :disabled="true"
                              v-model="item.poi_total_amount"
                              type="number"
                              name="totalrate"
                              id="totalrate"
                              v-validate="'required|decimal'"
                              placeholder="."
                            />
                            <label>{{ $t("total") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('totalrate')">{{
                            errors.first("totalrate")
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-1">
                    <div class="d-flex justify-content-center mb-2">
                      <button
                        v-if="vendorIndex === RawMaterialsList.length - 1"
                        @click.prevent.stop="addVendor(vendorIndex)"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/plus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                      <button
                        v-else
                        @click.prevent.stop="removeVendor(vendorIndex)"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </b-collapse>
        </div>

        <div
          v-if="false"
          v-for="(item, vendorIndex) in RawMaterialsList"
          :key="`_${vendorIndex}${vendorIndex}`"
          :class="`_${vendorIndex}${vendorIndex}`"
          class="col-md-12 mb-4"
        >
          <div class="row" style="border-bottom: 0.1px solid lightgrey">
            <div
              class="col-md-2"
              :key="`__${vendorIndex}${vendorIndex}`"
              :class="`__${vendorIndex}${vendorIndex}`"
            >
              <multiselect
                :key="`___${vendorIndex}${vendorIndex}`"
                :class="`___${vendorIndex}${vendorIndex}`"
                :options="showAll ? rawMaterialsNew : filterRW(rawMaterialsNew)"
                v-model="item.main_raw_material"
                :searchable="true"
                label="rm_name"
                track-by="rm_id"
                placeholder="Select Raw Material"
                @select="onSelectNewRawMaterial($event, vendorIndex, 0)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <p class="error_message">
                <span v-if="submitted && item.rm_name.length == 0"
                  >Please Select Raw Material.</span
                >
              </p>
            </div>
            <div class="">
              <div class="d-flex align-items-center mb-3 pt-2">
                <label class="mr-2">{{ "Show All" }}</label>
                <b-form-checkbox
                  class="j-checkbox mb-1 pb-0"
                  v-model="item.showAll"
                  name="check-button"
                ></b-form-checkbox>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.poi_qty"
                    type="number"
                    @input="calculateNetAmount(item)"
                    placeholder="Qty"
                  />
                  <label
                    :class="
                      item.poi_qty && item.poi_qty.length > 0 ? 'shift-up' : ''
                    "
                    >Qty</label
                  >
                </div>
              </div>
              <p
                v-if="submitted && item.poi_qty.length == 0"
                class="error_message"
              >
                Please Select Quantity.
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="item.uom_unit.length > 0 ? 'shift-up' : ''">
                    UOM</label
                  >
                  <b-dropdown
                    :text="item.uom_unit"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(measurement, measurementkey) in item.uom_units"
                      :key="measurementkey"
                      v-on:click="onSelectUom(measurement, vendorIndex)"
                      >{{ measurement.uom_unit }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <!-- <Tooltip :title="$t('purchaseOrder_selectUOM')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && item.uom_unit.length == 0"
                  >Please Select Unit of Measurement.</span
                >
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.poi_rate"
                    type="number"
                    @input="calculateNetAmount(item)"
                    placeholder="Qty"
                  />
                  <label
                    :class="
                      item.poi_rate && item.poi_rate.length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >Rate</label
                  >
                </div>
              </div>
              <p
                v-if="submitted && item.poi_rate.length == 0"
                class="error_message"
              >
                Please Select Rate.
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :disabled="true"
                    v-model="item.poi_price"
                    type="text"
                    name="netamount"
                    id="netamount"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("netAmount") }}</label>
                </div>
                <!-- <Tooltip :title="$t('purchaseOrder_NetAmount')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('netamount')">{{
                  errors.first("netamount")
                }}</span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="input-material">
                <input
                  v-model="item.poi_tax_in_percentage"
                  type="number"
                  name="taxamount"
                  id="taxamount"
                  @input="calculateNetAmount(item)"
                  v-validate="'required|decimal'"
                  placeholder="."
                />
                <label>{{ $t("Tax(In %)") }}</label>
              </div>
              <label
                style="font-size: 10px; font-weight: bold"
                v-if="item.poi_tax_amount"
                >Tax Amount ({{ item.poi_tax_amount }})</label
              >
              <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" />-->
              <p class="error_message">
                <span v-if="submitted && errors.has('taxamount')">{{
                  errors.first("taxamount")
                }}</span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.poi_total_amount"
                    type="text"
                    name="totalrate"
                    id="totalrate"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("totalamount") }}</label>
                </div>
                <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('totalrate')">{{
                  errors.first("totalrate")
                }}</span>
              </p>
            </div>

            <div
              class="col-lg-1 border-left d-flex align-items-center justify-content-center mb-2"
            >
              <button
                v-if="vendorIndex === RawMaterialsList.length - 1"
                @click="addVendor"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click="removeVendor(vendorIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12 mt-4 text-center">
          <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">
            {{ $t("update") }}</button
          >&nbsp;
          <button @click.prevent.stop="onCancel()" class="btn-outline-blue">
            {{ $t("cancel") }}</button
          >&nbsp;
          <!--          <router-link to="purchase-order" class="btn-outline-blue">{{
            $t("cancel")
          }}</router-link>-->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    data() {
      return {
        purchaseOrderErrorDetails: {
          errorMsg: "",
          hasError: false,
          errorIndexArray: [],
        },
        showAll: false,
        errIndex: null,
        collapseObj: {
          itemsArray: true,
        },
        isRoleID: true,
        submitted: false,
        purchasOrderDetails: {
          cinema_id: "",
          // rm_id: "",
          v_id: "",
          po_date: null,
          po_total_amount: null,
          po_lock: false,
          po_is_active: true,
          po_number: "",
          remarks: "",
        },
        searchRawMaterial: "",
        searchVendor: "",
        searchCinema: "",
        RawMaterialsList: [],
        VendorList: [],
        Cinemas: [],
        CinemasCopy: [],
        RawMaterials: [],
        RawMaterialsCopy: [],
        Vendors: [],
        VendorsCopy: [],
        measurements: [],
        selectedCinema: "",
        selectedRawMaterial: "",
        selectedVendor: "",
        selectedQuantity: "",
        selectedUom: "",
        po_number: "",
        listOfConversionRate: [],
        rawMaterialsNew: [],
        selectedRawMaterialPrice: [],
      };
    },
    async beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      this.getCinemaList(obj);
      const { po_number, po_id } = this.$route.query;
      if (po_id && po_number) {
        this.purchasOrderDetails.po_number = po_number;
        this.purchasOrderDetails.po_id = po_id;
        await this.getOrdersDetails();
      } else {
        this.$router.go(-1);
      }
      this.getRawMaterialsListMain();
    },
    mounted() {},
    computed: {
      defaultTaxPercent() {
        let taxPercent = "";
        if (CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME) {
          taxPercent = 10;
        }
        return taxPercent;
      },
      DISABLE_RAW_MATERIAL_UOM_SWITCH() {
        return this.$store.getters.DISABLE_RAW_MATERIAL_UOM_SWITCH || 'N';
      },
      isEpix() {
        return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
      },
    },
    methods: {
      filterRW(rm) {
        let filtered = rm.filter((rm) => {
          if (!this.purchasOrderDetails.v_id) return true;

          let v_ids = (rm.vendor_ids || "")
            .split(",")
            .map((x) => String(x).trim())
            .map((x) => parseInt(x));

          if (!rm.vendor_ids) return false;
          return v_ids.includes(parseInt(this.purchasOrderDetails.v_id));
        });

        // console.log({
        //   "rm.length": rm.length,
        //   "filtered.length": filtered.length
        // });
        // console.log({
        //   filtered
        // });

        return filtered;
      },
      onSelectNewRawMaterial(event, vendorIndex, rawKey, type) {
        if (type == "remove") {
          this.RawMaterialsList[vendorIndex]["main_raw_material"] = "";
          this.RawMaterialsList[vendorIndex].rm_name = "";
          this.RawMaterialsList[vendorIndex].rm_id = null;
          this.RawMaterialsList[vendorIndex].SelectedRawMaterial = "";
          this.RawMaterialsList[vendorIndex].uom_unit = "";
          this.RawMaterialsList[vendorIndex].uom_id = "";
          this.RawMaterialsList[vendorIndex].poi_qty = "";
          this.RawMaterialsList[vendorIndex].poi_rate = "";
          this.RawMaterialsList[vendorIndex].poi_tax_in_percentage = "";
        } else {
          console.log(event, vendorIndex, rawKey, "Rawww");
          let findIndexNew = this.RawMaterialsList.findIndex((x) => {
            return x.rm_id == String(event.rm_id);
          });
          console.log("findIndexNew", findIndexNew);
          if (findIndexNew >= 0) {
            this.$toasted.show(` ${event.rm_name} already selected `);
            this.RawMaterialsList[vendorIndex]["main_raw_material"] = true;
            return false;
          }
          let checkIndex = this.RawMaterials.findIndex((x) => {
            return x.rm_id == event.rm_id;
          });
          console.log(this.RawMaterials, checkIndex, "checkIndex");
          if (checkIndex >= 0) {
            this.onSelectRawMaterial(
              this.RawMaterials[checkIndex],
              vendorIndex,
              rawKey
            );
          } else {
            this.RawMaterialsList[vendorIndex]["rm_id"] = event.rm_id;
            this.RawMaterialsList[vendorIndex]["rm_name"] = event.rm_name;
            this.RawMaterialsList[vendorIndex]["rm_name"] = event.rm_name;
            this.RawMaterialsList[vendorIndex]["selectedUOM"] = {
              uom_id: event.uom_id,
              uom_short_form: event.uom_short_form,
              uom_unit: event.uom_unit,
            };
            this.RawMaterialsList[vendorIndex]["isNew"] = true;
            console.log("Raw Material Not Found In Vendor");
            this.getRelatedUom(vendorIndex, event.rm_id);
            console.log(this.RawMaterialsList);
            // } EXTEND
            this.RawMaterialsList[vendorIndex]["poi_tax_amount"] = "";
            (this.RawMaterialsList[vendorIndex]["poi_tax_in_percentage"] =
              this.defaultTaxPercent || ""),
              (this.RawMaterialsList[vendorIndex]["poi_total_amount"] = "");
            this.RawMaterialsList[vendorIndex]["po_quantity"] = "";
            this.RawMaterialsList[vendorIndex]["poi_qty"] = "";
            this.RawMaterialsList[vendorIndex]["poi_rate"] = "";
            this.RawMaterialsList[vendorIndex]["poi_price"] = "";
            this.RawMaterialsList[vendorIndex]["uom_units"] = [];
            this.RawMaterialsList[vendorIndex]["uom_id"] = event.uom_id;
            this.RawMaterialsList[vendorIndex]["uom_unit"] = event.uom_unit;
          }
        }
      },
      getRawMaterialsListMain: function() {
        this.rawMaterialsNew = [];
        let payload = {
          limit: 10000,
          currentPage: 1,
          searchKey: "rm_name",
          searchValue: "",
          columnName: "rm_name",
          orderBy: "asc",
          filter_is_active: "Y",
        };
        PosFnbService.GetRawMaterialsList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.rawMaterialsNew = data.Records;
              console.log(this.rawMaterialsNew);
            } else {
              this.$toasted.show("No Records Found");
            }
          })
          .catch(this._CatchError); //message
      },
      calculateNetAmount: function(item) {
        console.log(item);
        if (item.poi_rate && item.poi_qty) {
          item.poi_price = +parseFloat(item.poi_rate * item.poi_qty).toFixed(
            this.MIN_FRACTION_DIGITS
          );
        }

        if (
          item.poi_price &&
          (item.poi_tax_in_percentage || item.poi_tax_in_percentage == 0)
        ) {
          item.poi_tax_amount = +parseFloat(
            (item.poi_price * item.poi_tax_in_percentage) / 100
          ).toFixed(this.MIN_FRACTION_DIGITS);
        }

        if (
          item.poi_price &&
          (item.poi_tax_amount || item.poi_tax_amount == 0)
        ) {
          item.poi_total_amount = +parseFloat(
            item.poi_price + item.poi_tax_amount
          ).toFixed(this.MIN_FRACTION_DIGITS);
        }
        this.purchasOrderDetails.po_total_amount = 0;
        this.RawMaterialsList.map((x) => {
          if (x.poi_total_amount) {
            this.purchasOrderDetails.po_total_amount += parseFloat(
              x.poi_total_amount
            );
          }
        });

        item.poi_price = parseFloat(item.poi_price || 0).toFixed(
          this.MIN_FRACTION_DIGITS
        );
        item.poi_tax_amount = parseFloat(item.poi_tax_amount || 0).toFixed(
          this.MIN_FRACTION_DIGITS
        );
        item.poi_total_amount = parseFloat(item.poi_total_amount || 0).toFixed(
          this.MIN_FRACTION_DIGITS
        );
        this.purchasOrderDetails.po_total_amount = parseFloat(
          this.purchasOrderDetails.po_total_amount || 0
        ).toFixed(this.MIN_FRACTION_DIGITS);
      },
      onSearchRawMaterial: function(value) {
        if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
          this.RawMaterials = this.RawMaterialsCopy.filter((x) => {
            if (
              x.rm_name
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.RawMaterials = this.RawMaterialsCopy;
        }
      },
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      onSearchVendor: function(value) {
        if (this.searchVendor && this.searchVendor.length > 0) {
          this.Vendors = this.VendorsCopy.filter((x) => {
            if (
              x.v_name.toLowerCase().includes(this.searchVendor.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Vendors = this.VendorsCopy;
        }
      },
      getOrdersDetails: function() {
        let loader = this.$loading.show();

        let payload = {
          po_id: this.purchasOrderDetails.po_id,
        };
        PosFnbService.GetPurchaseOrderDetails(payload)
          .then(async (response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.purchasOrderDetails = data.Records[0];
              this.purchasOrderDetails.po_date = new Date(
                data.Records[0].po_date
              );
              this.purchasOrderDetails.po_total_amount = parseFloat(
                this.purchasOrderDetails.po_total_amount || 0
              ).toFixed(this.MIN_FRACTION_DIGITS);
              this.purchasOrderDetails.po_lock =
                this.purchasOrderDetails.po_lock == "Y" ? true : false;
              this.purchasOrderDetails.po_is_active =
                this.purchasOrderDetails.po_is_active == "Y" ? true : false;
              await this.getVendorsList(this.purchasOrderDetails.v_id);
              await this.setCinema(this.purchasOrderDetails.cinema_id);
              await this.getRawMaterials(
                data.Records,
                this.purchasOrderDetails.v_id
              );
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(async () => {
            setTimeout(() => loader.hide(), 1100);
          });
      },
      clearSelectedDate: function() {
        this.purchasOrderDetails.po_date = "";
      },
      setCinema: function(cinema_id) {
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemas({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.Cinemas = data.Records;
              // this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (x.cine_id == cinema_id) {
                  // this.selectedCinema = x.cine_name;
                  this.onSelectCinema({
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getCinemaList: function(cine_id) {
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              // this.Cinemas.map(x => {
              //   if (x.cine_id == cinema_id) {
              //     // this.selectedCinema = x.cine_name;
              //     this.onSelectCinema({
              //       cine_name: x.cine_name,
              //       cine_id: x.cine_id
              //     })
              //   }
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getunitsofmeasurements: function(uom_id, index) {
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.measurements = data.Records;
              this.measurements.map((x) => {
                if (x.uom_id == uom_id) {
                  this.VendorList[index].uom_unit = x.uom_unit;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getVendorsList: function(v_id) {
        let payload = {
          tableName: "ms_vendors",
          v_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Vendors = data.Records;
              this.VendorsCopy = data.Records;
              this.Vendors.map((x) => {
                if (x.v_id == v_id) {
                  this.purchasOrderDetails.v_id = v_id;
                  this.selectedVendor = x;
                }
              });
              // this.Vendors.map((x, index) => {
              //   if (x.v_id == v_id) {
              //     this.VendorList.push({
              //       v_name: x.v_name,
              //       v_id: x.v_id,
              //       po_total_amount: po_total_amount,
              //       po_quantity: String(po_quantity),
              //       uom_unit: "",
              //       uom_id: String(uom_id),
              //       po_id: po_id
              //     });
              //   }
              // });
              // this.VendorList.map((x, index) => {
              //   this.getunitsofmeasurements(uom_id, index);
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRawMaterials: function(Materials, vendor_id) {
        let loader = this.$loading.show();
        let payload = {
          vendor_id,
        };

        PosFnbService.GetVendorRateDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RawMaterials = data.Records;
              this.RawMaterialsCopy = data.Records;
              this.RawMaterials = this.RawMaterials.map((x) => {
                x["singleItemPrice"] =
                  parseFloat(x.vr_rate) / parseInt(x.vr_qty);
                x["selectedUOM"] = {
                  uom_id: x.uom_id,
                  uom_short_form: x.uom_short_form,
                  uom_unit: x.uom_unit,
                };
                x["uom_units"] = [];
                x["singleTaxPrice"] =
                  parseFloat(x.vr_tax_amount) / parseInt(x.vr_qty);
                x["singleTotalPrice"] = parseFloat(
                  x["singleItemPrice"] + x["singleTaxPrice"]
                ).toFixed(this.MIN_FRACTION_DIGITS);
                return x;
              });
              Materials.map((x, index) => {
                let singleItemPrice =
                  parseFloat(x.poi_price) / parseInt(x.poi_qty);
                let singleTaxPrice =
                  parseFloat(x.poi_tax_amount) / parseInt(x.poi_qty);
                let array = data.Records.filter(
                  ({ rm_id }) => rm_id === x.rm_id
                );

                this.RawMaterialsList.push({
                  showAll: false,
                  main_raw_material: array[0],
                  rm_name: x.rm_name,
                  rm_id: x.rm_id,
                  poi_qty: String(x.poi_qty),
                  po_quantity: String(x.poi_qty),
                  poi_price: parseFloat(x.poi_price).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                  poi_tax_amount: parseFloat(x.poi_tax_amount).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                  poi_rate: parseFloat(x.poi_rate).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                  poi_tax_in_percentage: String(x.poi_tax_in_percentage),
                  poi_total_amount: parseFloat(x.poi_total_amount).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                  uom_unit: x.uom_unit,
                  uom_id: x.uom_id,
                  poi_id: x.poi_id,
                  uom_units: [],
                  selectedUOM: {
                    uom_id: x.uom_id,
                    uom_short_form: x.uom_short_form,
                    uom_unit: x.uom_unit,
                  },
                  poi_is_active: true,
                  poi_remarks: x.poi_remarks || "",
                  vendor_rate_id: x.vendor_rate_id,
                  vr_id: x.vendor_rate_id,
                  singleItemPrice: parseFloat(singleItemPrice).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                  singleTaxPrice: parseFloat(singleTaxPrice).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                  singleTotalPrice: parseFloat(
                    singleItemPrice + singleTaxPrice
                  ).toFixed(this.MIN_FRACTION_DIGITS),
                  SelectedRawMaterial: array.length > 0 ? array[0] : {},
                  stock_in_id: x.stock_in_id || null,
                });
                this.getRelatedUom(index, x.rm_id);
              });
              // this.RawMaterials.map(x => {});
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(async () => {
            setTimeout(() => loader.hide(), 1100);
          });

        // let payload = {
        //   tableName: "ms_raw_materials",
        //   rm_is_active: "Y"
        // };
        // MasterService.GetActiveList(payload)
        //   .then(response => {
        //     const { data } = response;
        //     if (data && data.status && data.Records.length > 0) {
        //       this.RawMaterials = data.Records;
        //     } else {
        //       this.$toasted.show(data.message);
        //     }
        //   })
        //   .catch(this._CatchError)
        //   .finally(async () => {
        //     await this.getOrdersDetails();
        //     setTimeout(() => loader.hide(), 1100);
        //   });
      },
      onSelectCinema: function(params, type) {
        if (type == "remove") {
          this.selectedCinema = "";
          this.purchasOrderDetails.cinema_id = null;
        } else {
          this.selectedCinema = params;
          this.purchasOrderDetails.cinema_id = params.cine_id;
        }
      },

      onSelectRawMaterial: function(params, index, rawkey) {
        // this.RawMaterialsList[index].rm_name = params.rm_name;
        // this.RawMaterialsList[index].rm_id = String(params.rm_id);

        this.RawMaterialsList[index].rm_name = params.rm_name;
        this.RawMaterialsList[index].rm_id = String(params.rm_id);
        this.RawMaterialsList[index].SelectedRawMaterial = params;
        this.RawMaterialsList[index].uom_unit = params.uom_unit;
        this.RawMaterialsList[index].uom_id = params.uom_id;
        this.RawMaterialsList[index].selectedUOM = {
          uom_id: params.uom_id,
          uom_short_form: params.uom_short_form,
          uom_unit: params.uom_unit,
        };
        this.getRelatedUom(index, params.rm_id);
        // this.CalculateSelectedRawMaterial(
        //   this.RawMaterialsList[index]["poi_qty"],
        //   index
        // );
      },
      getRelatedUom: function(index, rm_id) {
        let cinema_id = this.purchasOrderDetails.cinema_id;
        PosFnbService.getUomFromRawMaterial({ rm_id, cinema_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.RawMaterialsList[index].uom_units = data.Records;
              this.listOfConversionRate = data.UnitMeasurement;
              if (data.RawMaterialPrice.length > 0) {
                let checkVendorExist = data.RawMaterialPrice.filter((z) => {
                  return (
                    String(z.vendor_id) == String(this.purchasOrderDetails.v_id)
                  );
                });
                this.selectedRawMaterialPrice = data.RawMaterialPrice;
                if (checkVendorExist.length > 0) {
                  if (data.Records.length == 1) {
                    console.log(
                      this.RawMaterialsList[index],
                      "poi_rate",
                      checkVendorExist
                    );
                    if (
                      checkVendorExist &&
                      checkVendorExist[0] &&
                      checkVendorExist[0].singleRate
                    ) {
                      this.RawMaterialsList[index].poi_rate = parseFloat(
                        checkVendorExist[0].singleRate
                      ).toFixed(this.MIN_FRACTION_DIGITS);
                      this.RawMaterialsList[index].uom_id =
                        checkVendorExist[0].uom_id;
                      this.RawMaterialsList[index].uom_unit =
                        this.RawMaterialsList[index].SelectedRawMaterial[
                          "uom_unit"
                        ] || null;
                      this.RawMaterialsList[index].poi_tax_amount = parseFloat(
                        checkVendorExist[0].singleTax
                      ).toFixed(this.MIN_FRACTION_DIGITS);
                      this.RawMaterialsList[
                        index
                      ].poi_tax_in_percentage = +parseFloat(
                        (checkVendorExist[0].singleTax * 100) /
                          checkVendorExist[0].singleRate
                      ).toFixed(this.MIN_FRACTION_DIGITS);
                    }
                  }
                }
              }

              this.$forceUpdate();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectVendor: function(params, index, type) {
        if (type == "remove") {
          this.selectedVendor = "";
          this.purchasOrderDetails.v_id = null;
        } else {
          this.selectedVendor = params;
          this.purchasOrderDetails.v_id = params.v_id;
        }
      },
      onSelectQuantity: function(params, index) {
        this.RawMaterialsList[index]["poi_qty"] = params.toString();
        console.log(
          'this.RawMaterialsList[index]["poi_qty"] :',
          this.RawMaterialsList[index]["poi_qty"]
        );
        this.CalculateSelectedRawMaterial(
          this.RawMaterialsList[index]["poi_qty"],
          index
        );
      },
      CalculateSelectedRawMaterial: function(params, index) {
        console.log("params :", params);
        console.log("params :t", typeof params);
        console.log("index :", index);
        if (String(params).length > 0) {
          this.RawMaterialsList[index]["vendor_rate_id"] =
            this.RawMaterialsList[index].SelectedRawMaterial["vr_id"] || null;

          // this.RawMaterialsList[index]["uom_unit"] =
          //   this.RawMaterialsList[index].SelectedRawMaterial["uom_unit"] || null;
          // // // uom_id
          // this.RawMaterialsList[index]["uom_id"] =
          //   this.RawMaterialsList[index].SelectedRawMaterial["uom_id"] || null;
          this.RawMaterialsList[index]["poi_is_active"] = true;

          let fromUnit = this.listOfConversionRate.filter((x) => {
            console.log(x);
            return (
              x.conversion_from ==
              this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
            );
          });

          let toUnit = this.listOfConversionRate.filter((x) => {
            console.log(x);
            return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
          });

          if (fromUnit.length > 0 && toUnit.length > 0) {
            let from_kg =
              this.RawMaterialsList[index].SelectedRawMaterial["vr_qty"] *
              fromUnit[0].conversion_formula;
            let to_kg = parseInt(params) * toUnit[0].conversion_formula;
            let net_amount = parseFloat(
              (to_kg / from_kg) *
                this.RawMaterialsList[index].SelectedRawMaterial["vr_rate"]
            ).toFixed(this.MIN_FRACTION_DIGITS);
            let tax_amount = parseFloat(
              (to_kg / from_kg) *
                this.RawMaterialsList[index].SelectedRawMaterial[
                  "vr_tax_amount"
                ]
            ).toFixed(this.MIN_FRACTION_DIGITS);
            let poi_total_amount = parseFloat(net_amount + tax_amount).toFixed(
              this.MIN_FRACTION_DIGITS
            );
            this.RawMaterialsList[index]["poi_price"] = net_amount;
            this.RawMaterialsList[index]["poi_tax_amount"] = tax_amount;
            this.RawMaterialsList[index]["poi_total_amount"] = poi_total_amount;
          } else {
            this.RawMaterialsList[index]["poi_price"] =
              parseInt(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleItemPrice"
              ];

            this.RawMaterialsList[index]["poi_tax_amount"] =
              parseInt(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleTaxPrice"
              ];

            this.RawMaterialsList[index]["poi_total_amount"] =
              parseInt(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleTotalPrice"
              ];
          }

          console.log(fromUnit, toUnit);
          this.purchasOrderDetails.po_total_amount = 0;
          this.RawMaterialsList.map((x) => {
            this.purchasOrderDetails.po_total_amount += parseFloat(
              x.poi_total_amount
            );
          });
        }
      },

      onSelectUom: function(params, index) {
        console.log(params);
        this.RawMaterialsList[index].uom_unit = params.uom_unit;
        this.RawMaterialsList[index].uom_id = params.uom_id;
        let checkVendorExist = this.selectedRawMaterialPrice.filter((z) => {
          return String(z.vendor_id) == String(this.purchasOrderDetails.v_id);
        });
        let fromUnit = this.listOfConversionRate.filter((x) => {
          return (
            x.conversion_from ==
            this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
          );
        });

        let toUnit = this.listOfConversionRate.filter((x) => {
          return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
        });

        console.log(fromUnit, toUnit, checkVendorExist);

        if (
          fromUnit.length > 0 &&
          toUnit.length > 0 &&
          checkVendorExist.length
        ) {
          console.log(1);
          let from_kg = 1 * fromUnit[0].conversion_formula;
          let to_kg = parseInt(1) * toUnit[0].conversion_formula;
          let net_amount = parseFloat(
            (to_kg / from_kg) * checkVendorExist[0]["singleRate"]
          ).toFixed(this.MIN_FRACTION_DIGITS);
          let tax_amount = parseFloat(
            (to_kg / from_kg) * checkVendorExist[0]["singleTax"]
          ).toFixed(this.MIN_FRACTION_DIGITS);
          console.log(tax_amount, net_amount);
          this.RawMaterialsList[index].poi_rate = +parseFloat(
            net_amount / 1
          ).toFixed(4);
          this.RawMaterialsList[index].poi_tax_amount = +parseFloat(
            tax_amount
          ).toFixed(this.MIN_FRACTION_DIGITS);
          this.RawMaterialsList[index].poi_price =
            net_amount * (this.RawMaterialsList[index].poi_qty || 1);
          this.RawMaterialsList[index].poi_tax_in_percentage = +parseFloat(
            (this.RawMaterialsList[index].poi_tax_amount * 100) /
              this.RawMaterialsList[index].poi_price
          ).toFixed(4);
          this.RawMaterialsList[index]["poi_total_amount"] =
            this.RawMaterialsList[index].poi_price +
            this.RawMaterialsList[index].poi_tax_amount;

          if (this.RawMaterialsList[index].poi_qty) {
            this.purchasOrderDetails.po_total_amount = 0;
            this.RawMaterialsList.map((x) => {
              if (x.poi_total_amount) {
                this.purchasOrderDetails.po_total_amount += parseFloat(
                  x.poi_total_amount
                );
              }
            });
          }

          this.purchasOrderDetails.po_total_amount = parseFloat(
            this.purchasOrderDetails.po_total_amount
          ).toFixed(this.MIN_FRACTION_DIGITS);
        }

        // this.CalculateSelectedRawMaterial(
        //   this.RawMaterialsList[index].poi_qty,
        //   index
        // );
      },
      onSelectUom: function(params, index) {
        this.RawMaterialsList[index].uom_unit = params.uom_unit;
        this.RawMaterialsList[index].uom_id = params.uom_id;
        let checkVendorExist = this.selectedRawMaterialPrice.filter((z) => {
          return String(z.vendor_id) == String(this.purchasOrderDetails.v_id);
        });
        let fromUnit = this.listOfConversionRate.filter((x) => {
          return (
            x.conversion_from ==
            this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
          );
        });

        let toUnit = this.listOfConversionRate.filter((x) => {
          return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
        });

        console.log(fromUnit, toUnit, checkVendorExist);

        if (
          fromUnit.length > 0 &&
          toUnit.length > 0 &&
          checkVendorExist.length
        ) {
          console.log(1);
          let from_kg = 1 * fromUnit[0].conversion_formula;
          let to_kg = parseInt(1) * toUnit[0].conversion_formula;
          let net_amount = parseFloat(
            (to_kg / from_kg) * checkVendorExist[0]["singleRate"]
          ).toFixed(this.MIN_FRACTION_DIGITS);
          let tax_amount = parseFloat(
            (to_kg / from_kg) * checkVendorExist[0]["singleTax"]
          ).toFixed(this.MIN_FRACTION_DIGITS);
          console.log(tax_amount, net_amount);
          this.RawMaterialsList[index].poi_rate = +parseFloat(
            net_amount / 1
          ).toFixed(4);
          this.RawMaterialsList[index].poi_tax_amount = +parseFloat(
            tax_amount * (this.RawMaterialsList[index].poi_qty || 1)
          ).toFixed(this.MIN_FRACTION_DIGITS);
          this.RawMaterialsList[index].poi_price =
            net_amount * (this.RawMaterialsList[index].poi_qty || 1);
          this.RawMaterialsList[index].poi_tax_in_percentage = +parseFloat(
            (tax_amount * 100) / net_amount
          ).toFixed(4);
          this.RawMaterialsList[index]["poi_total_amount"] =
            this.RawMaterialsList[index].poi_price +
            this.RawMaterialsList[index].poi_tax_amount;
          console.log(
            'this.RawMaterialsList[index]["poi_total_amount"]',
            this.RawMaterialsList[index]["poi_total_amount"]
          );
          console.log(
            'this.RawMaterialsList[index]["poi_price"]',
            this.RawMaterialsList[index]["poi_price"]
          );
          console.log(
            'this.RawMaterialsList[index]["poi_tax_amount"]',
            this.RawMaterialsList[index]["poi_tax_amount"]
          );
          console.log(
            'this.RawMaterialsList[index]["poi_tax_in_percentage"]',
            this.RawMaterialsList[index]["poi_tax_in_percentage"]
          );
          if (this.RawMaterialsList[index].poi_qty) {
            this.purchasOrderDetails.po_total_amount = 0;
            this.RawMaterialsList.map((x) => {
              if (x.poi_total_amount) {
                this.purchasOrderDetails.po_total_amount += parseFloat(
                  x.poi_total_amount
                );
              }
            });
          }

          //   let poi_total_amount = parseFloat(net_amount + tax_amount).toFixed(this.MIN_FRACTION_DIGITS);
          //   this.RawMaterialsList[index]["poi_price"] = net_amount;
          //   this.RawMaterialsList[index]["poi_tax_amount"] = tax_amount;
          //   this.RawMaterialsList[index]["poi_total_amount"] = poi_total_amount;
          //   this.RawMaterialsList[index]["poi_total_amount"] =
          //     parseInt(params) *
          //     this.RawMaterialsList[index].SelectedRawMaterial["singleTotalPrice"];
          // }
          // this.CalculateSelectedRawMaterial(
          //   this.RawMaterialsList[index].poi_qty,
          //   index
          // );
        }
      },
      addVendor: function() {
        this.RawMaterialsList.push({
          showAll: false,
          rm_name: "",
          rm_id: "",
          main_raw_material: "",
          poi_price: "",
          poi_tax_amount: "",
          poi_rate: "",
          poi_tax_in_percentage: this.defaultTaxPercent || "",
          poi_total_amount: "",
          po_quantity: "",
          poi_qty: "",
          uom_unit: "",
          uom_id: "",
          po_total_amount: "",
          SelectedRawMaterial: null,
          uom_units: [],
          selectedUOM: "",
          poi_remarks: "",
          poi_is_active: true,
        });
      },
      removeVendor: function(index) {
        this.RawMaterialsList.splice(index, 1);
      },
      onCancel: function() {
        if (this.$route.query.fromBulkEdit) {
          this.$router.go(-1);
        } else {
          this.$router.push({
            path: "purchase-order",
          });
        }
      },
      validatePurchaseOrderArray() {
        let errorCount = 0;
        let errorMsg = ``;
        let errIndex = null;
        this.purchaseOrderErrorDetails["hasError"] = false;
        this.purchaseOrderErrorDetails["errorMsg"] = "";
        this.purchaseOrderErrorDetails["errorIndexArray"] = [];
        this.RawMaterialsList.map((row, index) => {
          if (
            (row.rm_id || row.uom_id || row.poi_qty || row.poi_rate) &&
            (!row.rm_id || !row.uom_id || !row.poi_qty || !row.poi_rate)
          ) {
            errorCount++;
            errorMsg = `Incomplete Row. Please Fill the Details Properly`;
            errIndex = index;

            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = errorMsg;
            this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          } else if (row.poi_qty < 0 || row.poi_rate < 0) {
            errorCount++;
            errorMsg = `Invalid Values. Negative Values are not allowed.`;
            errIndex = index;

            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = errorMsg;
            this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          }
        });
        if (errorCount > 0) {
          console.log(
            "this.purchaseOrderErrorDetails",
            this.purchaseOrderErrorDetails
          );
          this.$toasted.show(errorMsg);
          return false;
        } else {
          return true;
        }
      },
      onFinalSubmit: function() {
        this.submitted = true;
        let checkValid = this.validatePurchaseOrderArray();
        let finalPurchaseArray = this.RawMaterialsList.filter(
          (x) =>
            x.rm_id &&
            x.uom_id &&
            !isNaN(String(x.poi_rate)) &&
            !isNaN(String(x.poi_qty))
        );
        finalPurchaseArray.forEach((_rm) => {
          _rm["uom_id"] = _rm["selectedUOM"]["uom_id"];
          _rm["uom_unit"] = _rm["selectedUOM"]["uom_unit"];
        });
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid && checkValid) {
            let loader = this.$loading.show();
            let payload = {
              ...this.purchasOrderDetails,
              purchaseOrder: finalPurchaseArray,
            };
            PosFnbService.UpdatePurchaseOrder(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  if (this.$route.query.fromBulkEdit) {
                    this.$router.go(-1);
                  } else {
                    this.$router.push({
                      path: "purchase-order",
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                loader.hide();
              });
          }
        });
      },
    },
  };
</script>

<style>
  .sectionName {
    padding: 5px 0px;
    color: var(--blue);
  }
  .sectionName .fs-17 {
    font-size: 17px !important;
  }
  .text-small-instruction {
    font-weight: 400;
  }
  .text-red {
    color: red;
  }

  .percentText {
    color: black;
    font-size: 15px;
    font-weight: bold;
    position: relative;
    padding-inline: 8px;
  }

  .qtyInput {
    border-radius: 5px;
    border: 1px solid #777575;
    width: 80%;
    height: 30px;
  }

  .disable-field {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .bor {
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }
  .back {
    background-color: #fff;
  }
  .inner-vendor-rate {
    background-color: #fff;
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }

  .po_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .po_input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .po_input input::placeholder,
  .po_wrapper .multiselect__placeholder {
    font-size: 10px !important;
    font-style: italic !important;
  }

  .input_text-center input {
    text-align: center;
  }

  .input_text-right input {
    text-align: right;
  }

  .po_wrapper .multiselect__placeholder {
    font-weight: unset !important;
    line-height: 25px;
  }

  .purchase_input::placeholder {
    font-size: 10px !important;
    font-style: italic !important;
  }

  .noItemsClass {
    text-align: center;
    width: 100%;
    margin: 16px auto;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
  }

  .taxPopOver {
    zoom: 0.8;
    min-width: 200px;
  }

  .errRow {
    border: 2px solid red;
  }
  .borderNone {
    border: none !important;
  }

  .complete-tick {
    width: 120px;
    height: 120px;
    display: inline-block;
    background-size: contain;
  }

  .errorLine {
    color: red;
    border: 1px solid red;
  }

  .redLine {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/editPurchaseOrder.vue